import Vue from 'vue'

export default function RefreshEventTimer(callback, second) {
    const self = this
    self.lastRefreshAt = null
    self.queuedTimeoutId = null
    self.callback = callback
    self.miliSecond = second * 1000

    self.triggerCallback = () => {
        self.queuedTimeoutId = null
        self.lastRefreshAt = Vue.prototype.$date()
        self.callback()
    }

    self.fire = () => {
        const now = Vue.prototype.$date()
        const elapsed = now - self.lastRefreshAt

        if (elapsed >= self.miliSecond) {
            self.triggerCallback()
            return
        }

        const remaining = self.miliSecond - elapsed
        if (self.queuedTimeoutId == null) {
            self.queuedTimeoutId = setTimeout(self.triggerCallback, remaining)
        }
    }
}
